/**
 * 公共处理mixin
 */
export default {
  inject: {
    domain: {
      form: 'domain',
      default: () => {
        return ''
      }
    }
  },
  computed: {
    mode () {
      return this.$attrs.mode === 'view' ? true : false
    },
    textEdit () {
      return this.$attrs.mode === 'fastSite'
    }
  },
  methods: {
    // 点击显示配置文件
    handleClickItem (idx, dom, e) {
      !this.mode && this.$emit('curClickNode', { idx, dom, e })
    },
    // 打开页面/第三方链接
    openUrl (url) {
      if (url && this.mode) {
        if (url.startsWith('http')) {
          window.open(url, '_blank')
        } else {
          window.open(this.domain ? `${this.domain}${url}` : url, '_blank')
        }
      }
    }
  }
}
